<div class="h-100" *ngIf="modalData.type === 'success'">
    <div class="modal-dialog h-100">
        <div class="modal-content h-100 p-4">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Success!</h5>
                <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"
                    (click)="close()"></button>
            </div>
            <div class="modal-body d-flex align-items-center">Text uploaded successfully.</div>
            <div class="modal-footer">
                <button type="button" class="btn btn-dark" data-mdb-dismiss="modal" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="h-100" *ngIf="modalData.type === 'failure'">
    <div class="modal-dialog h-100">
        <div class="modal-content h-100 p-4">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Failure!</h5>
                <button type="button" class="btn-close" data-mdb-dismiss="modal" aria-label="Close"
                    (click)="close()"></button>
            </div>
            <div class="modal-body d-flex align-items-center">Text upload failed.</div>
            <div class="modal-footer">
                <button type="button" class="btn btn-dark text-capitalize shadow-0" data-mdb-dismiss="modal"
                    (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="h-100" *ngIf="modalData.type === 'alert'">
    <div class="modal-dialog h-100">
        <div class="modal-content h-100">
            <div class="modal-header ps-4 pe-4 pt-3 pb-2">
                <h5 class="modal-title" id="exampleModalLabel">Alert!</h5>
                <button type="button" class="btn-close text-capitalize" data-mdb-dismiss="modal" aria-label="Close"
                    (click)="close()"></button>
            </div>
            <hr />
            <div class="modal-body ps-4 pe-4 pt-2 pb-2 d-flex align-items-center" [innerHTML]="modalData.message">
            </div>
            <hr />
            <div class="modal-footer ps-4 pe-4 pt-2 pb-3">
                <button type="button" class="btn btn-dark text-capitalize shadow-0" data-mdb-dismiss="modal"
                    (click)="confirm()">Confirm</button>
                <button type="button" class="btn btn-dark ms-2 text-capitalize shadow-0" data-mdb-dismiss="modal"
                    (click)="close()">Cancel</button>
            </div>
        </div>
    </div>
</div>